var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "active",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20.1 22.6",
    style: {
      enableBackground: "new 0 0 20.1 22.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.1,15.2L16.1,15.2c-0.3-0.3-0.6-0.9-0.6-1.3v-0.5c0,0-0.1,0-0.1,0c-0.5,0-0.9-0.1-1.4-0.2v0.7 c0,0.8,0.4,1.8,1,2.4l0.6,0.6c0.2,0.2,0.4,0.6,0.5,1H1.7c0.1-0.4,0.3-0.8,0.5-1l0.6-0.6c0.6-0.6,1-1.6,1-2.4V8.4 c0-2.8,2.3-5.1,5.1-5.1c0.7,0,1.4,0.1,2,0.4c0.3-0.4,0.7-0.8,1.2-1C11.4,2.3,10.5,2,9.7,1.9V1.1c0-0.4-0.3-0.7-0.7-0.7 c-0.4,0-0.7,0.3-0.7,0.7v0.8C4.9,2.2,2.4,5,2.4,8.4v5.5c0,0.4-0.3,1.1-0.6,1.3l-0.6,0.6c-0.6,0.6-1,1.6-1,2.4v0.4 c0,0.4,0.3,0.7,0.7,0.7h5.8V20c0,1.2,1,2.2,2.2,2.2s2.2-1,2.2-2.2v-0.7H17c0.4,0,0.7-0.3,0.7-0.7v-0.4c0-0.8-0.4-1.8-1-2.4 L16.1,15.2z M9.7,20.1c0,0.4-0.3,0.7-0.7,0.7c-0.4,0-0.7-0.3-0.7-0.7v-0.7h1.5V20.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 15.2,
    cy: 7.6,
    r: 4.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellActive);
export default __webpack_public_path__ + "static/media/bell-active.0d78e535f4f22ee1ff664f81a9b6ddd6.svg";
export { ForwardRef as ReactComponent };